module.exports = __webpack_public_path__ + "img/ic_close_rounded.53868b4e.svg";